import React, { useState, useEffect, useRef } from 'react';
import { supabase } from '../../../supabaseClient';

// ── Componente Bandera (mismo sistema que FixtureMundial) ─────────────────────
const Loader = ({ texto = 'Cargando...' }) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', gap: '20px' }}>
    <div style={{ position: 'relative', width: '56px', height: '56px' }}>
      <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', border: '3px solid #0f172a' }} />
      <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', border: '3px solid transparent', borderTopColor: '#00f2ff', animation: 'spin 0.9s linear infinite' }} />
      <div style={{ position: 'absolute', inset: '8px', borderRadius: '50%', border: '2px solid transparent', borderTopColor: '#a855f7', animation: 'spin 1.4s linear infinite reverse' }} />
    </div>
    <p style={{ color: '#475569', fontSize: '0.78rem', letterSpacing: '2px', textTransform: 'uppercase', margin: 0 }}>{texto}</p>
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

const BANDERA_KEY = {
  'Mexico':'mexico','South Africa':'sudafrica','Korea Republic':'corea',
  'Czechia':'czechia','Canada':'canada','Bosnia-Herzegovina':'bosnia',
  'USA':'usa','Paraguay':'paraguay','Qatar':'qatar','Switzerland':'suiza',
  'Brazil':'brasil','Morocco':'marruecos','Haiti':'haiti','Scotland':'escocia',
  'Australia':'australia','Turkey':'turquia','Germany':'alemania',
  'Netherlands':'paises-bajos','Japan':'japon','Ecuador':'ecuador',
  'Sweden':'suecia','Spain':'espana','Belgium':'belgica','Egypt':'egipto',
  'Saudi Arabia':'arabia-saudita','Uruguay':'uruguay','Iran':'iran',
  'New Zealand':'nueva-zelanda','France':'francia','Senegal':'senegal',
  'Iraq':'irak','Norway':'noruega','Argentina':'argentina','Algeria':'argelia',
  'Austria':'austria','Portugal':'portugal','England':'inglaterra',
  'Croatia':'croacia','Ghana':'ghana','Panama':'panama','Colombia':'colombia',
  'Serbia':'serbia','Denmark':'dinamarca','Italy':'italia','Chile':'chile',
  'Venezuela':'venezuela','Honduras':'honduras','Nigeria':'nigeria',
  'Cameroon':'camerun','Jamaica':'jamaica','Mali':'mali','Costa Rica':'costa-rica',
  'DR Congo':'congo','Congo DR':'congo',
  'Tunisia':'tunez',
  "Côte d'Ivoire":'costa-marfil',
  'Cabo Verde':'cabo-verde','Curaçao':'curacao','IR Iran':'iran',
  'Jordan':'jordania','Uzbekistan':'uzbekistan',
  // Aliases en español (nombres como vienen de la DB)
  'México':'mexico','Sudáfrica':'sudafrica','Corea del Sur':'corea',
  'Chequia':'czechia','Canadá':'canada','Bosnia y Herzegovina':'bosnia',
  'Estados Unidos':'usa','Qatar':'qatar','Suiza':'suiza',
  'Brasil':'brasil','Marruecos':'marruecos','Haití':'haiti','Escocia':'escocia',
  'Australia':'australia','Turquía':'turquia','Alemania':'alemania',
  'Países Bajos':'paises-bajos','Japón':'japon','Ecuador':'ecuador',
  'Suecia':'suecia','España':'espana','Bélgica':'belgica','Egipto':'egipto',
  'Arabia Saudita':'arabia-saudita','Uruguay':'uruguay','Irán':'iran',
  'Nueva Zelanda':'nueva-zelanda','Francia':'francia','Senegal':'senegal',
  'Iraq':'irak','Noruega':'noruega','Argentina':'argentina','Argelia':'argelia',
  'Austria':'austria','Portugal':'portugal','Inglaterra':'inglaterra',
  'Croacia':'croacia','Ghana':'ghana','Panamá':'panama','Colombia':'colombia',
  'DR Congo':'congo','Túnez':'tunez','Costa de Marfil':'costa-marfil',
  'Cabo Verde':'cabo-verde','Curazao':'curacao','Jordania':'jordania',
  'Uzbekistán':'uzbekistan','Paraguay':'paraguay',
};
const EMOJIS_FLAG = {
  'Mexico':'🇲🇽','South Africa':'🇿🇦','Korea Republic':'🇰🇷','Czechia':'🇨🇿',
  'Canada':'🇨🇦','Bosnia-Herzegovina':'🇧🇦','USA':'🇺🇸','Paraguay':'🇵🇾',
  'Qatar':'🇶🇦','Switzerland':'🇨🇭','Brazil':'🇧🇷','Morocco':'🇲🇦',
  'Haiti':'🇭🇹','Scotland':'🏴󠁧󠁢󠁳󠁣󠁴󠁿','Australia':'🇦🇺','Turkey':'🇹🇷',
  'Germany':'🇩🇪','Netherlands':'🇳🇱','Japan':'🇯🇵','Ecuador':'🇪🇨',
  'Sweden':'🇸🇪','Spain':'🇪🇸','Belgium':'🇧🇪','Egypt':'🇪🇬',
  'Saudi Arabia':'🇸🇦','Uruguay':'🇺🇾','Iran':'🇮🇷','New Zealand':'🇳🇿',
  'France':'🇫🇷','Senegal':'🇸🇳','Iraq':'🇮🇶','Norway':'🇳🇴',
  'Argentina':'🇦🇷','Algeria':'🇩🇿','Austria':'🇦🇹','Portugal':'🇵🇹',
  'England':'🏴󠁧󠁢󠁥󠁮󠁧󠁿','Croatia':'🇭🇷','Ghana':'🇬🇭','Panama':'🇵🇦',
  'Colombia':'🇨🇴','Serbia':'🇷🇸','Denmark':'🇩🇰','Italy':'🇮🇹',
  'Chile':'🇨🇱','Venezuela':'🇻🇪','Honduras':'🇭🇳','Nigeria':'🇳🇬',
  'Cameroon':'🇨🇲','Jamaica':'🇯🇲','Mali':'🇲🇱','Costa Rica':'🇨🇷',
  'DR Congo':'🇨🇩','Congo DR':'🇨🇩',
  'Tunisia':'🇹🇳',
  "Côte d'Ivoire":'🇨🇮',
  'Cabo Verde':'🇨🇻','Curaçao':'🇨🇼','IR Iran':'🇮🇷',
  'Jordan':'🇯🇴','Uzbekistan':'🇺🇿',
  // Aliases en español
  'México':'🇲🇽','Sudáfrica':'🇿🇦','Corea del Sur':'🇰🇷','Chequia':'🇨🇿',
  'Canadá':'🇨🇦','Bosnia y Herzegovina':'🇧🇦','Estados Unidos':'🇺🇸','Paraguay':'🇵🇾',
  'Qatar':'🇶🇦','Suiza':'🇨🇭','Brasil':'🇧🇷','Marruecos':'🇲🇦',
  'Haití':'🇭🇹','Escocia':'🏴󠁧󠁢󠁳󠁣󠁴󠁿','Australia':'🇦🇺','Turquía':'🇹🇷',
  'Alemania':'🇩🇪','Países Bajos':'🇳🇱','Japón':'🇯🇵','Ecuador':'🇪🇨',
  'Suecia':'🇸🇪','España':'🇪🇸','Bélgica':'🇧🇪','Egipto':'🇪🇬',
  'Arabia Saudita':'🇸🇦','Uruguay':'🇺🇾','Irán':'🇮🇷','Nueva Zelanda':'🇳🇿',
  'Francia':'🇫🇷','Senegal':'🇸🇳','Iraq':'🇮🇶','Noruega':'🇳🇴',
  'Argentina':'🇦🇷','Argelia':'🇩🇿','Austria':'🇦🇹','Portugal':'🇵🇹',
  'Inglaterra':'🏴󠁧󠁢󠁥󠁮󠁧󠁿','Croacia':'🇭🇷','Ghana':'🇬🇭','Panamá':'🇵🇦',
  'Colombia':'🇨🇴','DR Congo':'🇨🇩','Túnez':'🇹🇳','Costa de Marfil':'🇨🇮',
  'Cabo Verde':'🇨🇻','Curazao':'🇨🇼','Jordania':'🇯🇴','Uzbekistán':'🇺🇿',
};

const { useState: useSt } = React;
const Bandera = ({ equipo, size=28 }) => {
  const [err, setErr] = useSt(false);
  const key = BANDERA_KEY[equipo];
  if (!key || err)
    return <span style={{ fontSize:size*0.75, lineHeight:1 }}>{EMOJIS_FLAG[equipo]||''}</span>;
  return <img src={`/banderas/${key}.jpg`} alt={equipo} onError={() => setErr(true)}
    style={{ width:size, height:Math.round(size*0.67), objectFit:'cover', borderRadius:3, border:'1px solid rgba(255,255,255,0.1)' }} />;
};
// Compatibilidad con código existente que usa flag()
const flag = (name) => EMOJIS_FLAG[name] || '';

// ── Formatear hora Argentina (UTC-3) ─────────────────────────────────────────
const horaAR = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit', timeZone: 'America/Argentina/Buenos_Aires' });
};
const fechaCorta = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', timeZone: 'America/Argentina/Buenos_Aires' });
};

// ── Colores estado partido ────────────────────────────────────────────────────
const ESTADO_COLOR = { programado: '#475569', 'en curso': '#22c55e', finalizado: '#64748b' };
const ESTADO_LABEL = { programado: 'PRÓXIMO', 'en curso': '● EN VIVO', finalizado: 'FINAL' };

// ── Modal de partido ──────────────────────────────────────────────────────────
const ModalPartido = ({ partido, onClose }) => {
  if (!partido) return null;
  return (
    <div onClick={e => e.target === e.currentTarget && onClose()}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.88)', backdropFilter: 'blur(10px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#080d14', border: '1px solid #1e293b', borderRadius: '16px', padding: '32px', width: '480px', maxWidth: '92vw', position: 'relative' }}>
        <button onClick={onClose} style={{ position: 'absolute', top: '16px', right: '16px', background: 'none', border: 'none', color: '#475569', fontSize: '1.4rem', cursor: 'pointer' }}>×</button>

        {/* Grupo + jornada */}
        <div style={{ display: 'flex', gap: '8px', marginBottom: '20px', flexWrap: 'wrap' }}>
          {partido.grupo && <span style={{ background: '#00f2ff15', border: '1px solid #00f2ff33', color: '#00f2ff', padding: '2px 10px', borderRadius: '20px', fontSize: '0.75rem', fontWeight: 'bold' }}>GRUPO {partido.grupo}</span>}
          <span style={{ background: '#1e293b', color: '#64748b', padding: '2px 10px', borderRadius: '20px', fontSize: '0.75rem' }}>{partido.jornada_nombre}</span>
          <span style={{ marginLeft: 'auto', color: ESTADO_COLOR[partido.estado] || '#475569', fontSize: '0.75rem', fontWeight: 'bold' }}>{ESTADO_LABEL[partido.estado] || partido.estado?.toUpperCase()}</span>
        </div>

        {/* Resultado */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
          <div style={{ textAlign: 'center' }}>
            <Bandera equipo={partido.equipo_local} size={44} />
            <div style={{ color: '#ffffff', fontWeight: 'bold', fontSize: '0.95rem' }}>{NOMBRE_GRUPO[partido.equipo_local] || partido.equipo_local}</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            {partido.estado === 'finalizado' || partido.estado === 'en curso'
              ? <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#fff', letterSpacing: '4px' }}>
                  {partido.goles_local ?? 0} — {partido.goles_visitante ?? 0}
                </div>
              : <div style={{ color: '#475569', fontSize: '1rem', fontWeight: 'bold' }}>VS</div>
            }
            <div style={{ color: '#475569', fontSize: '0.78rem', marginTop: '4px' }}>
              {fechaCorta(partido.hora)} · {horaAR(partido.hora)} hs
            </div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <Bandera equipo={partido.equipo_visitante} size={44} />
            <div style={{ color: '#e2e8f0', fontWeight: 'bold', fontSize: '0.95rem' }}>{NOMBRE_GRUPO[partido.equipo_visitante] || partido.equipo_visitante}</div>
          </div>
        </div>

        {/* Estadio */}
        {partido.estadio && (
          <div style={{ textAlign: 'center', color: '#334155', fontSize: '0.78rem', borderTop: '1px solid #1e293b', paddingTop: '12px' }}>
             {partido.estadio}{partido.ciudad ? ` · ${partido.ciudad}` : ''}
          </div>
        )}
      </div>
    </div>
  );
};

// ── Componente principal ──────────────────────────────────────────────────────
// ── Nombres en español para el fixture y grupos ──────────────────────────────
const NOMBRE_GRUPO = {
  'Mexico':'México','Brazil':'Brasil','France':'Francia','Spain':'España',
  'Germany':'Alemania','England':'Inglaterra','Portugal':'Portugal',
  'Netherlands':'Países Bajos','Belgium':'Bélgica','Italy':'Italia',
  'Croatia':'Croacia','Uruguay':'Uruguay','Colombia':'Colombia',
  'USA':'EE.UU.','Japan':'Japón','Korea Republic':'Corea del Sur',
  'Morocco':'Marruecos','Senegal':'Senegal','Canada':'Canadá','Ecuador':'Ecuador',
  'Qatar':'Qatar','Australia':'Australia','Switzerland':'Suiza','Denmark':'Dinamarca',
  'Serbia':'Serbia','Turkey':'Turquía','Scotland':'Escocia',
  'Saudi Arabia':'Arabia Saudita','Panama':'Panamá','Jamaica':'Jamaica',
  'Honduras':'Honduras','Nigeria':'Nigeria','Cameroon':'Camerún','Egypt':'Egipto',
  'Mali':'Mali','Iraq':'Irak','New Zealand':'Nueva Zelanda','Chile':'Chile',
  'Venezuela':'Venezuela','Paraguay':'Paraguay','Sweden':'Suecia',
  'South Africa':'Sudáfrica','Haiti':'Haití','Bosnia-Herzegovina':'Bosnia-Herz.',
  'Czechia':'Chequia','Austria':'Austria','Norway':'Noruega','Algeria':'Argelia',
  'Ghana':'Ghana','DR Congo':'Congo DR','Congo DR':'Congo DR',
  'Costa Rica':'Costa Rica','Iran':'Irán','Argentina':'Argentina',
  'Cabo Verde':'Cabo Verde','Curaçao':'Curazao','IR Iran':'Irán',
  'Jordan':'Jordania','Uzbekistan':'Uzbekistán',
};

const MundialPage = () => {
  const [partidos, setPartidos]       = useState([]);
  const [posiciones, setPosiciones]   = useState([]);
  const [loading, setLoading]         = useState(true);
  const [jornada, setJornada]         = useState(null); // null = todas
  const [partidoModal, setPartidoModal] = useState(null);
  const [grupoActivo, setGrupoActivo] = useState(0);
  const [paginaGrupos, setPaginaGrupos] = useState(0);
  const [goleadores, setGoleadores] = useState([]);
  const GRUPOS = ['A','B','C','D','E','F','G','H','I','J','K','L'];

  useEffect(() => {
    const cargar = async () => {
      setLoading(true);
      const [{ data: pts }, { data: pars }, { data: data_goles }] = await Promise.all([
        supabase.from('mundial_grupo_posiciones').select('*').order('grupo').order('puntos', { ascending: false }).order('dg', { ascending: false }).order('gf', { ascending: false }),
        supabase.from('mundial_partidos').select('*').order('hora'),
        supabase.from('mundial_goleadores').select('*').order('goles', { ascending: false }),
      ]);
      setGoleadores(data_goles || []);
      setPosiciones(pts || []);
      setPartidos(pars || []);
      setLoading(false);
    };
    cargar();

    // ⚠️ NO BORRAR: Realtime — actualiza resultados y posiciones cuando el admin los carga
    // No consume requests externas, es websocket a la propia DB
    const canal = supabase
      .channel('mundial_updates')
      .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'mundial_partidos' }, (payload) => {
        setPartidos(prev => prev.map(p => p.id === payload.new.id ? { ...p, ...payload.new } : p));
      })
      .on('postgres_changes', { event: 'UPDATE', schema: 'public', table: 'mundial_grupo_posiciones' }, () => {
        // Recargar posiciones completas cuando cambian (son muchas filas relacionadas)
        supabase.from('mundial_grupo_posiciones').select('*')
          .order('grupo').order('puntos', { ascending: false }).order('dg', { ascending: false }).order('gf', { ascending: false })
          .then(({ data }) => { if (data) setPosiciones(data); });
      })
      .subscribe();

    return () => supabase.removeChannel(canal);
  }, []);

  // Jornadas disponibles
  const jornadas = [...new Set(partidos.map(p => p.jornada_nombre))].filter(Boolean);
  const jornadaActiva = jornada || jornadas[0];
  const partidosFiltrados = partidos.filter(p => !jornadaActiva || p.jornada_nombre === jornadaActiva);

  // Agrupar fixture por fecha
  const porFecha = {};
  partidosFiltrados.forEach(p => {
    const f = fechaCorta(p.hora);
    if (!porFecha[f]) porFecha[f] = [];
    porFecha[f].push(p);
  });

  // Posiciones del grupo activo
  const grupoNombre = GRUPOS[grupoActivo];
  const posGrupo = posiciones.filter(p => p.grupo === grupoNombre);

  if (loading) return <Loader texto="Cargando Mundial..." />;

  return (
    <div className="mundial-root" style={{ padding: '16px 24px', color: 'white', minHeight: 'calc(100vh - var(--navbar-h))', background: '#020b18' }}>

      {/* Header */}
      <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '12px' }}>
        <div>
          <h1 style={{ margin: 0, fontSize: '1.5rem', letterSpacing: '1px' }}>
            <span style={{ color: '#00f2ff' }}>MUNDIAL</span> 2026
          </h1>
          <p style={{ margin: 0, color: '#b0b0b0', fontSize: '0.9rem' }}>USA · México · Canadá</p>
        </div>
      </div>

      {/* 3 COLUMNAS FIJAS */}
      <div className="mundial-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(480px, 100%), 1fr))', gap: '24px', alignItems: 'start' }}>

        {/* ── IZQ: Grupos paginados 3x página ── */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {/* Header alineado con selector J1/J2/J3 — misma altura */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px', minHeight: '31px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{ color: '#00f2ff', fontWeight: 'bold', fontSize: '1.2rem', letterSpacing: '1px' }}>
                GRUPOS {GRUPOS[paginaGrupos*3]}–{GRUPOS[Math.min(paginaGrupos*3+2, 11)]}
              </span>
              <span style={{ color: '#a4aab1', fontSize: '1rem' }}>{paginaGrupos+1}/4</span>
              {/* dots inline */}
              <div style={{ display:'flex', gap:'3px', marginLeft:'6px' }}>
                {[0,1,2,3].map(i => <div key={i} onClick={() => setPaginaGrupos(i)} style={{ width: paginaGrupos===i?14:5, height:5, borderRadius:3, background:paginaGrupos===i?'#00f2ff':'#1e293b', cursor:'pointer', transition:'all 0.2s' }} />)}
              </div>
            </div>
            <div style={{ display: 'flex', gap: '3px' }}>
              <button onClick={() => setPaginaGrupos(p => Math.max(0, p-1))} disabled={paginaGrupos===0}
                style={{ padding:'5px 10px', borderRadius:'6px', background:paginaGrupos>0?'#1e293b':'transparent', border:'1px solid '+(paginaGrupos>0?'#334155':'#1e293b'), color:paginaGrupos>0?'#94a3b8':'#1e293b', cursor:paginaGrupos>0?'pointer':'default', fontSize:'0.75rem' }}>‹</button>
              <button onClick={() => setPaginaGrupos(p => Math.min(3, p+1))} disabled={paginaGrupos===3}
                style={{ padding:'5px 10px', borderRadius:'6px', background:paginaGrupos<3?'#1e293b':'transparent', border:'1px solid '+(paginaGrupos<3?'#334155':'#1e293b'), color:paginaGrupos<3?'#94a3b8':'#1e293b', cursor:paginaGrupos<3?'pointer':'default', fontSize:'0.75rem' }}>›</button>
            </div>
          </div>
          {GRUPOS.slice(paginaGrupos*3, paginaGrupos*3+3).map(grupo => {
            const pos = posiciones.filter(p => p.grupo === grupo).sort((a,b) => b.puntos-a.puntos||b.dg-a.dg||b.gf-a.gf);
            const slots = pos.length > 0 ? pos : new Array(4).fill({equipo:'',pj:0,pg:0,pe:0,pp:0,gf:0,gc:0,dg:0,puntos:0});
            const cols = [
              { key:'pj',  label:'PJ', color:'#64748b' },
              { key:'pg',  label:'G',  color:'#64748b' },
              { key:'pe',  label:'E',  color:'#64748b' },
              { key:'pp',  label:'P',  color:'#64748b' },
              { key:'gf',  label:'GF', color:'#64748b' },
              { key:'gc',  label:'GC', color:'#64748b' },
              { key:'dg',  label:'DG', color:'#64748b' },
              { key:'puntos', label:'PTS', color:'#00f2ff' },
            ];
            return (
              <div key={grupo} style={{ background:'#080d14', border:'1px solid #1e293b', borderRadius:'9px', overflow:'hidden' }}>
                {/* Header */}
                <div style={{ padding:'5px 9px', background:'#0a0f19', borderBottom:'1px solid #1e293b', display:'flex', alignItems:'center' }}>
                  <span style={{ color:'#00f2ff', fontWeight:'bold', fontSize:'0.73rem', flex:1 }}>GRUPO {grupo}</span>
                  <div style={{ display:'flex', gap:'6px' }}>
                    {cols.map(c => (
                      <span key={c.key} style={{ color: c.color, fontSize:'0.62rem', fontWeight:'bold', width: c.key === 'puntos' ? '22px' : '16px', textAlign:'center', letterSpacing:'0.5px' }}>
                        {c.label}
                      </span>
                    ))}
                  </div>
                </div>
                {/* Filas */}
                {slots.map((eq, i) => {
                  const clasificado = i < 2 && pos.length > 0;
                  return (
                    <div key={i} style={{ display:'flex', alignItems:'center', gap:'5px', padding:'4px 9px', borderBottom:i<3?'1px solid #0f172a':'none', background:clasificado?'#ffffff04':'transparent' }}>
                      <span style={{ color:clasificado?'#22c55e':'#334155', fontSize:'0.72rem', width:'9px', flexShrink:0 }}>{i+1}</span>
                      {eq.equipo ? <Bandera equipo={eq.equipo} size={15} /> : <div style={{width:15,height:10,background:'#1e293b',borderRadius:2,flexShrink:0}} />}
                      <span style={{ color:clasificado?'#e2e8f0':'#475569', fontSize:'0.78rem', flex:1, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                        {eq.equipo || '—'}
                      </span>
                      <div style={{ display:'flex', gap:'6px' }}>
                        {cols.map(c => (
                          <span key={c.key} style={{
                            color: c.key === 'puntos' ? (clasificado ? '#00f2ff' : '#475569') :
                                   c.key === 'dg' && eq[c.key] > 0 ? '#22c55e' :
                                   c.key === 'dg' && eq[c.key] < 0 ? '#ef4444' : '#334155',
                            fontWeight: c.key === 'puntos' ? 'bold' : 'normal',
                            fontSize:'0.72rem',
                            width: c.key === 'puntos' ? '22px' : '16px',
                            textAlign:'center',
                          }}>
                            {c.key === 'dg' && eq[c.key] > 0 ? `+${eq[c.key]||0}` : eq[c.key]||0}
                          </span>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>

        {/* ── CENTRO: Fixture ── */}
        <div>
          {/* Selector de jornada */}
          <div style={{ display: 'flex', gap: '6px', marginBottom: '12px', flexWrap: 'wrap' }}>
            {jornadas.map(j => (
              <button key={j} onClick={() => setJornada(j === jornadaActiva && jornada ? null : j)}
                style={{ padding: '5px 14px', background: jornadaActiva === j ? '#00f2ff22' : '#080d14', border: '1px solid ' + (jornadaActiva === j ? '#00f2ff' : '#1e293b'), borderRadius: '20px', color: jornadaActiva === j ? '#00f2ff' : '#475569', fontSize: '0.75rem', fontWeight: 'bold', cursor: 'pointer', transition: '0.15s', whiteSpace: 'nowrap' }}>
                {j.replace('Jornada ', 'J').replace(' — Grupos', '')}
              </button>
            ))}
          </div>

          {/* Partidos agrupados por fecha */}
          {Object.entries(porFecha).map(([fecha, ps]) => (
            <div key={fecha} style={{ marginBottom: '16px' }}>
              <div style={{ color: '#b0b0b0', fontSize: '0.8rem', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '6px', paddingLeft: '4px' }}>
                {fecha}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                {ps.map(p => {
                  const estadoColor = ESTADO_COLOR[p.estado] || '#475569';
                  const esFinalizado = p.estado === 'finalizado';
                  const esEnCurso = p.estado === 'en curso';
                  return (
                    <div key={p.id} onClick={() => setPartidoModal(p)}
                      style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center', gap: '8px', padding: '7px 12px', background: '#080d14', border: '1px solid ' + (esEnCurso ? '#22c55e44' : '#1e293b'), borderRadius: '10px', cursor: 'pointer', transition: '0.15s', boxShadow: esEnCurso ? '0 0 12px #22c55e22' : 'none' }}
                      onMouseEnter={e => e.currentTarget.style.borderColor = '#00f2ff44'}
                      onMouseLeave={e => e.currentTarget.style.borderColor = esEnCurso ? '#22c55e44' : '#1e293b'}>

                      {/* Local */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'flex-end' }}>
                        <span style={{ color: '#e2e8f0', fontSize: '0.85rem', fontWeight: esFinalizado || esEnCurso ? 'bold' : '400', textAlign: 'right' }}>{NOMBRE_GRUPO[p.equipo_local] || p.equipo_local}</span>
                        <Bandera equipo={p.equipo_local} size={28} />
                      </div>

                      {/* Centro: resultado o hora */}
                      <div style={{ textAlign: 'center', minWidth: '80px' }}>
                        {esFinalizado || esEnCurso ? (
                          <>
                            <div style={{ color: '#b80505', fontWeight: 'bold', fontSize: '1rem', letterSpacing: '2px' }}>
                              {p.goles_local ?? 0} — {p.goles_visitante ?? 0}
                            </div>
                            <div style={{ color: estadoColor, fontSize: '0.6rem', fontWeight: 'bold', marginTop: '1px' }}>
                              {ESTADO_LABEL[p.estado]}
                            </div>
                          </>
                        ) : (
                          <>
                            <div style={{ color: '#b0b0b0', fontWeight: 'bold', fontSize: '0.85rem' }}>{horaAR(p.hora)} ARG</div>
                          </>
                        )}
                      </div>

                      {/* Visitante */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Bandera equipo={p.equipo_visitante} size={28} />
                        <span style={{ color: '#e2e8f0', fontSize: '0.85rem', fontWeight: esFinalizado || esEnCurso ? 'bold' : '400' }}>{NOMBRE_GRUPO[p.equipo_visitante] || p.equipo_visitante}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* ── DER: Goleadores + Asistidores ── */}
        <div className="mundial-col-der" style={{ display:'flex', flexDirection:'column', gap:'12px' }}>

          {/* Spacer para alinear con J1/J2/J3 */}
          <div style={{ minHeight: '43px', display: 'flex', alignItems: 'center' }}>
            <span style={{ color: '#00f2ff', fontWeight: 'bold', fontSize: '0.75rem', letterSpacing: '1px' }}>ESTADÍSTICAS</span>
          </div>

          {/* Goleadores */}
          <div style={{ background:'#080d14', border:'1px solid #1e293b', borderRadius:'10px', overflow:'hidden' }}>
            <div style={{ padding:'8px 12px', borderBottom:'1px solid #1e293b' }}>
              <span style={{ color:'#22c55e', fontWeight:'bold', fontSize:'0.73rem', letterSpacing:'1px' }}>GOLEADORES</span>
            </div>
            {goleadores.length === 0 ? (
              <p style={{ color:'#334155', textAlign:'center', padding:'16px 10px', fontSize:'0.75rem' }}>Disponible al inicio del torneo</p>
            ) : (
              <div>
                <div style={{ display:'flex', padding:'4px 10px', background:'#0a0f19', borderBottom:'1px solid #1e293b' }}>
                  <span style={{ color:'#334155', fontSize:'0.55rem', flex:1 }}>JUGADOR</span>
                  <span style={{ color:'#22c55e', fontSize:'0.55rem', width:'26px', textAlign:'center' }}>GOL</span>
                </div>
                {[...goleadores].filter(g => g.goles > 0).sort((a,b) => b.goles-a.goles).slice(0,10).map((g,i) => (
                  <div key={g.id+'g'} style={{ display:'flex', alignItems:'center', gap:'6px', padding:'5px 10px', borderBottom:'1px solid #0f172a' }}>
                    <span style={{ color:i===0?'#f59e0b':i===1?'#94a3b8':i===2?'#cd7f32':'#475569', fontSize:'0.65rem', width:'14px', flexShrink:0 }}>{i+1}</span>
                    <Bandera equipo={g.seleccion} size={17} />
                    <span style={{ color:'#e2e8f0', fontSize:'0.75rem', flex:1, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{g.nombre}</span>
                    <span style={{ color:'#22c55e', fontWeight:'bold', fontSize:'0.82rem', width:'26px', textAlign:'center' }}>{g.goles}</span>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Asistidores */}
          <div style={{ background:'#080d14', border:'1px solid #1e293b', borderRadius:'10px', overflow:'hidden' }}>
            <div style={{ padding:'8px 12px', borderBottom:'1px solid #1e293b' }}>
              <span style={{ color:'#3b82f6', fontWeight:'bold', fontSize:'0.73rem', letterSpacing:'1px' }}>ASISTIDORES</span>
            </div>
            {goleadores.length === 0 ? (
              <p style={{ color:'#334155', textAlign:'center', padding:'16px 10px', fontSize:'0.75rem' }}>Disponible al inicio del torneo</p>
            ) : (
              <div>
                <div style={{ display:'flex', padding:'4px 10px', background:'#0a0f19', borderBottom:'1px solid #1e293b' }}>
                  <span style={{ color:'#334155', fontSize:'0.55rem', flex:1 }}>JUGADOR</span>
                  <span style={{ color:'#3b82f6', fontSize:'0.55rem', width:'26px', textAlign:'center' }}>ASI</span>
                </div>
                {[...goleadores].sort((a,b) => b.asistencias-a.asistencias).filter(g => g.asistencias > 0).slice(0,10).map((g,i) => (
                  <div key={g.id+'a'} style={{ display:'flex', alignItems:'center', gap:'6px', padding:'5px 10px', borderBottom:'1px solid #0f172a' }}>
                    <span style={{ color:i===0?'#f59e0b':i===1?'#94a3b8':i===2?'#cd7f32':'#475569', fontSize:'0.65rem', width:'14px', flexShrink:0 }}>{i+1}</span>
                    <Bandera equipo={g.seleccion} size={17} />
                    <span style={{ color:'#e2e8f0', fontSize:'0.75rem', flex:1, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{g.nombre}</span>
                    <span style={{ color:'#3b82f6', fontWeight:'bold', fontSize:'0.82rem', width:'26px', textAlign:'center' }}>{g.asistencias}</span>
                  </div>
                ))}
                {goleadores.every(g => !g.asistencias) && (
                  <p style={{ color:'#334155', textAlign:'center', padding:'12px', fontSize:'0.75rem' }}>Sin asistencias cargadas</p>
                )}
              </div>
            )}
          </div>

        </div>

      </div>

      {/* Modal partido */}
      <ModalPartido partido={partidoModal} onClose={() => setPartidoModal(null)} />
    </div>
  );
};

export default MundialPage;